import { Panel, PanelBody, PanelGrid, PanelGridItem, PanelHeader, PanelLink, PanelTitle } from 'components';
import { Link } from 'react-router-dom';
import { RepayDetailHeaderData } from 'types/RepayDetailHeaderData';
import styles from './RepayDetailsHeader.module.scss';

type Props = {
    repayDetailHeader: RepayDetailHeaderData
}

export default function RepayDetailHeader({ repayDetailHeader }: Props) {

    return (
        <Panel className={styles.panel}>
            <PanelHeader className={styles.header}>
                <PanelLink>
                    <Link to={'/search'}>Back to Search</Link>
                </PanelLink>
                <div className={styles.heading}>
                    <PanelTitle>{repayDetailHeader.repayNumber} | {repayDetailHeader.vendorId}</PanelTitle>
                </div>
            </PanelHeader>
            <PanelBody className={styles.body}>
                <PanelGrid className={styles.grid}>
                    <div className={styles.gridItem}>
                        <PanelGridItem
                            label={"Customer Number: "}
                            value={<span>{repayDetailHeader.customerId}</span>}
                        />
                    </div>
                    <div className={styles.gridItem}>
                        <PanelGridItem
                            label={"Customer Name: "}
                            value={<span>{repayDetailHeader.customerName}</span>}
                        />
                    </div>
                    <div className={styles.gridItem}>
                        <PanelGridItem
                            label={"Claimed For: "}
                            value={<span>Payment #{repayDetailHeader.paymentIdRef ? repayDetailHeader.paymentIdRef : " Not Available"}</span>}
                        />
                    </div>
                    <div className={styles.gridItem}>
                        <PanelGridItem
                            label={"Type: "}
                            value={<span>{repayDetailHeader.type}</span>}
                        />
                    </div>
                </PanelGrid>
            </PanelBody>
        </Panel>
    )
}